import { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
import { useNavigate } from 'react-router-dom';

import { fetch_all, fetch_one } from '../../lib/server_helper';

// import {
//   IconButton
// } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import StarIcon from '@mui/icons-material/Star';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import VisibilityIcon from '@mui/icons-material/Visibility';

import { DataGrid } from '../../components/interface/DataGrid';
import { Page } from '../../components/interface/Page';
import { SearchBox } from '../../components/interface/SearchBox';
import { StyledButton } from '../../components/interface/StyledButton';
import { StyledIconButton } from '../../components/interface/StyledIconButton';

import { Frontpager } from '../../models/Frontpager';
import { loginAtom } from '../../lib/auth';

type ContentFrontpagersProps = {};

export const ContentFrontpagers: FunctionComponent<ContentFrontpagersProps> = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const [login, setLogin] = useAtom(loginAtom);
  const [frontpagers, setFrontpagers] = useState<Frontpager[]>([]);
  const [frontpagersCount, setFrontpagersCount] = useState<number>(0);
  const [loader, setLoader] = useState<boolean>(true);
  const [removeLoader, setRemoveLoader] = useState<boolean>(false);
  const [page, setPage] = useState<number>(0);
  const [order, setOrder] = useState<string>("id DESC");

  useEffect(() => {
    onSearch('');
  }, [page, order]);

  const onRemove = (id: number) => {
    setRemoveLoader(true);
    fetch_one<Frontpager>('/nl/v3/objects/remove', {
      object: 'frontpager',
      ob: {
        id: id
      }
    }, (obs, complete_data) => {
      onSearch('');
      setRemoveLoader(false);
    }, (z) => {

    }, login);
  };

  const onSearch = (s: string, filters?:{enabled:string[]}) => {
    setLoader(true);
    fetch_all<Frontpager>('/nl/v3/objects/fetch_all', {
      object: 'frontpager',
      fields: ['id', 'title', 'body', 'cta_link', 'cta_text', 'enabled', 'v2_enabled', 'enabled_offices', 'has_cta', 'lang_nl', 'lang_fr'],
      per_page: 20,
      page: page,
      order: order,
      filter: {
        search: s,
        advanced: {
          // enabled: (filters?.enabled || ['1'])
        }
      }
    }, (obs, complete_data) => {
      setFrontpagers(obs);

      let count:number = 0;
      if (typeof(complete_data?.data) === 'object' && 'count' in complete_data?.data) count = complete_data?.data?.count;
      setFrontpagersCount(count);

      setLoader(false);
    }, (z) => {

    }, login);
  };

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 80 },
    { field: 'title_nl', headerName: 'Title', width: 400, sortable: false },
    { field: 'enabled', headerName: 'Website', width: 80, sortable: false, renderCell: params => <>
      {!!params.row.enabled && <CheckIcon sx={{color: theme.palette.tertiary?.main}} />}
      {!params.row.enabled && <CloseIcon sx={{color: theme.palette.secondary.main}} />}
    </> },
    { field: 'v2_enabled', headerName: 'NewSite', width: 80, sortable: false, renderCell: params => <>
      {!!params.row.v2_enabled && <CheckIcon sx={{color: theme.palette.tertiary?.main}} />}
      {!params.row.v2_enabled && <CloseIcon sx={{color: theme.palette.secondary.main}} />}
    </> },
    { field: 'enabled_offices', headerName: 'Backoffice', width: 80, sortable: false, renderCell: params => <>
      {!!params.row.enabled_offices && <CheckIcon sx={{color: theme.palette.tertiary?.main}} />}
      {!params.row.enabled_offices && <CloseIcon sx={{color: theme.palette.secondary.main}} />}
    </> },
    { field: 'has_cta', headerName: 'CTA', width: 40, sortable: false, renderCell: params => <>
      {!!params.row.has_cta&& <CheckIcon sx={{color: theme.palette.tertiary?.main}} />}
      {!params.row.has_cta && <CloseIcon sx={{color: theme.palette.secondary.main}} />}
    </> },
    { field: 'lang_nl', headerName: 'NL', width: 40, sortable: false, renderCell: (params) => <>
      {params?.value < 1 && <StarOutlineIcon sx={{color: 'red'}} />}
      {params?.value > 99 && <StarIcon sx={{color: theme.palette.tertiary?.main}} />}
      {params?.value <= 99 && params?.value >= 1 && <StarHalfIcon sx={{color: 'orange'}} />}
    </> },
    { field: 'lang_fr', headerName: 'FR', width: 40, sortable: false, renderCell: (params) => <>
      {params?.value < 1 && <StarOutlineIcon sx={{color: 'red'}} />}
      {params?.value > 99 && <StarIcon sx={{color: theme.palette.tertiary?.main}} />}
      {params?.value <= 99 && params?.value >= 1 && <StarHalfIcon sx={{color: 'orange'}} />}
    </> },
  ];

  return (
    <Page sx={{}} title="Frontpagers" helper="frontpagers" old_url="https://old.argenco.be/frontpagers" actions={<>
      <StyledButton
        label="Create new"
        id='create_new'
        contained
        path={'/frontpager/new'}
        sx={{marginRight: 3}}
        startIcon={<AddCircleOutlineIcon />}
      />
    </>}>
      <SearchBox
        simple={true}
        onSearch={(s, x) => {
          setPage(0);
          onSearch(s, x);
        }}
        // filter_enabled
        memo="frontpagers"
      />
      <DataGrid
        action_count={2}
        actions={(params) => {
          return (<>
            <StyledIconButton color="primary" path={`/frontpager/${params.row.id}`}>
              <VisibilityIcon />
            </StyledIconButton>
            {!removeLoader && <StyledIconButton destroyBtn color="primary" onClick={(e) => {
              onRemove(params.row.id);
            }}>
              <DeleteForeverIcon />
            </StyledIconButton>}
          </>);
        }}
        getRowClassName={(params) => `datagrid-row-enabled-${params.row.enabled || params.row.v2_enabled || params.row.enabled_offices}`}
        objectCount={frontpagersCount}
        objects={(frontpagers || []).map(u => ({
          ...u,
          title_nl: u.title?.nl || u.title
        }))}
        columns={columns}
        loader={loader}
        onSortModelChange={(a, b) => {
          let a_0_field:string = a[0].field;
          setOrder([a_0_field, a[0].sort].join(' '));
        }}
        page={page}
        setPage={(p) => {setPage(p);}}
      />
    </Page>
  );
}
